import { Router } from 'vue-router'

export const onSearchSubmit = (router: Router, searchText: string): void => {
  if (!searchText || !searchText.trim()?.length) {
    return
  }
  if (router.currentRoute.value.name?.toString().includes('search')) {
    router.replace({
      query: {
        q: searchText,
      },
    })
    return
  }
  const isChannelSearch = ['channel-overview', 'channel-search'].includes(
    router.currentRoute.value.name as string
  )

  router.push({
    name: isChannelSearch ? 'channel-search' : 'group-home-search',
    query: {
      q: searchText,
    },
  })
}

/** List of routes name, where search icon should be visible */
export const searchVisibleRoutes = [
  `home`,
  `channel-overview`,
  'channel-post-view',
  'group-post-view',

  /** Group Member List */
  'group-member-list',
]
